<div class="flex flex-col gap-4">
  <div>
    <h5 class="text-2xl">
      {{ 'components.organizationContactInfo.title' | translate }}
    </h5>
  </div>
  <div class="flex flex-col">
    @for (field of organizationFields(); track field[0]) {
      @let value = field[1];
      <span class="" [ngClass]="{ 'text-text-secondary italic': !value }">
        {{
          value ??
            (`components.organizationContactInfo.missing.${field[0]}`
              | translate)
        }}
      </span>
    }
  </div>
  <div>
    <button class="btn-secondary btn" (click)="editOrganizationInfo()">
      {{ 'components.organizationContactInfo.changeInfo' | translate }}
    </button>
  </div>
</div>
